export const DPE_QUALIF_STEPS = {
  COMPLETING_OWNER_COUNT: 1,
  COMPLETING_OWNERS_DETAILS: 2,
  REDIRECTION_TO_DPE_OR_IDENTIFIED: 3,
  DISPLAY_OWNERS_DETAILS: 4,
  MODIFICATION_SINGLE_OWNER_DETAILS: 5,
};
